function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.9285 9.628C17.8365 9.399 15.6115 4 9.9995 4C4.3875 4 2.1625 9.399 2.0705 9.628C1.9765 9.867 1.9765 10.133 2.0705 10.372C2.1625 10.601 4.3875 16 9.9995 16C15.6115 16 17.8365 10.601 17.9285 10.372C18.0225 10.133 18.0225 9.867 17.9285 9.628ZM9.9995 14C7.7905 14 5.9995 12.209 5.9995 10C5.9995 7.791 7.7905 6 9.9995 6C12.2095 6 13.9995 7.791 13.9995 10C13.9995 12.209 12.2095 14 9.9995 14ZM9.9995 8C8.8955 8 7.9995 8.896 7.9995 10C7.9995 11.104 8.8955 12 9.9995 12C11.1045 12 11.9995 11.104 11.9995 10C11.9995 8.896 11.1045 8 9.9995 8Z",
  fill: "#212B36"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 4,
  width: 16,
  height: 12
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.9285 9.628C17.8365 9.399 15.6115 4 9.9995 4C4.3875 4 2.1625 9.399 2.0705 9.628C1.9765 9.867 1.9765 10.133 2.0705 10.372C2.1625 10.601 4.3875 16 9.9995 16C15.6115 16 17.8365 10.601 17.9285 10.372C18.0225 10.133 18.0225 9.867 17.9285 9.628ZM9.9995 14C7.7905 14 5.9995 12.209 5.9995 10C5.9995 7.791 7.7905 6 9.9995 6C12.2095 6 13.9995 7.791 13.9995 10C13.9995 12.209 12.2095 14 9.9995 14ZM9.9995 8C8.8955 8 7.9995 8.896 7.9995 10C7.9995 11.104 8.8955 12 9.9995 12C11.1045 12 11.9995 11.104 11.9995 10C11.9995 8.896 11.1045 8 9.9995 8Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var SvgEyes = function SvgEyes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eyes.bfae07ab.svg";
export { ForwardRef as ReactComponent };